const upsertThreadEvent = ({ threadId, event } = {}) => {
  return {
    type: 'pieveUpsertThreadEvent',
    payload: { threadId, event }
  };
};

export default upsertThreadEvent;
